/**
 * Live session counts, one way for every place that shows them: Overview's tile and each
 * project's row add up to the same numbers. Pure, so it is tested.
 */
import type { Session } from '@orgus/protocol';
import { formatInt } from '@orgus/ui';

export interface LiveSessionCounts {
  working: number;
  waiting: number;
  idle: number;
  /** working + waiting + idle: every session with a live process. */
  live: number;
}

export function liveSessionCounts(sessions: Iterable<Pick<Session, 'status'>>): LiveSessionCounts {
  const c = { working: 0, waiting: 0, idle: 0, live: 0 };
  for (const s of sessions) {
    if (s.status === 'working') c.working++;
    else if (s.status === 'waiting') c.waiting++;
    else if (s.status === 'idle') c.idle++;
    else continue;
    c.live++;
  }
  return c;
}

/** "3 working, 2 waiting, 5 idle" with the zero parts left out; "None live" when all are. */
export function liveSessionText(c: LiveSessionCounts): string {
  const parts = [c.working && `${formatInt(c.working)} working`, c.waiting && `${formatInt(c.waiting)} waiting`, c.idle && `${formatInt(c.idle)} idle`].filter(Boolean);
  return parts.length ? parts.join(', ') : 'None live';
}
